<script context="module">
    import { apiMethods } from "../../../Services/index.svelte";
    import { insuranceTypesMayAllowAmaBillingRule } from "../../../Utils/utilConstants.svelte";
    import { DirectInsuranceType } from "../../../Utils/utilEnums.svelte";

    import {
        getInsuranceType,
        isObjectEmpty,
    } from "../../../Utils/utilFunctions.svelte";
    import { isHBFWAProviderChoiceEncounter } from "./encounterHelper.svelte";

    import { convertTimeRangeInMin } from "./mbsHelper.svelte";

     export const getMinScheduleFeeBasedOnRule = (
        ruleType,
        fundData,
        isQuote = true,
        billingData = {},
    ) => {
        if (fundData != null) {
            const { items } = fundData;

            const itemsRebateSum = items.reduce(
                (sum, { hfRebate }) => sum + hfRebate,
                0,
            );
            let percent = 100;
            switch (ruleType) {
                case 6: {
                    //mbs
                    var mbsRebateItemsSum = items.reduce(
                        (sum, { benefit100 }) => sum + benefit100,
                        0,
                    );
                    if(mbsRebateItemsSum > 0) {
                         percent = (itemsRebateSum / mbsRebateItemsSum) * 100;
                        return percent;
                    }
                    break;
                }
                case 7: {
                    //DVA
                    var dvaRebateItemsSum = items.reduce(
                        (sum, { rebateDva }) => sum + rebateDva,
                        0,
                    );
                    if(dvaRebateItemsSum > 0) {
                        percent = (itemsRebateSum / dvaRebateItemsSum) * 100;
                        return percent;
                    }
                    break;
                }
                   
                case 8: {
                    //BUPA
                    var bupaRebateItemsSum = items.reduce(
                        (sum, { rebateBupa }) => sum + rebateBupa,
                        0,
                    );
                    if(bupaRebateItemsSum > 0) {
                        percent = (itemsRebateSum / bupaRebateItemsSum) * 100;
                        return percent;
                    }
                    break;
                }
                    
                case 9: {
                    //AHSA
                    var ahsaRebateItemsSum = items.reduce(
                        (sum, { rebateAhsa }) => sum + rebateAhsa,
                        0,
                    );
                    if(ahsaRebateItemsSum > 0){
                        percent = (itemsRebateSum / ahsaRebateItemsSum) * 100;
                        return percent;
                    }
                    break;
                }
                case 10: {
                    //MEDIBANK
                    var medibankRebateItemsSum = items.reduce(
                        (sum, { rebateMedibank }) => sum + rebateMedibank,
                        0,
                    );
                    if (medibankRebateItemsSum > 0){
                        percent = (itemsRebateSum / medibankRebateItemsSum) * 100;
                        return percent;
                    }
                    break;
                }
                case 11: {
                    //NIB
                    var nibRebateItemsSum = items.reduce(
                        (sum, { rebateNib }) => sum + rebateNib,
                        0,
                    );
                    if(nibRebateItemsSum > 0){
                        percent = (itemsRebateSum / nibRebateItemsSum) * 100;
                        return percent;
                    }
                    break;
                }
                case 12: {
                    //HCF
                    var hcfRebateItemsSum = items.reduce(
                        (sum, { rebateHcf }) => sum + rebateHcf,
                        0,
                    );
                    if(hcfRebateItemsSum > 0){
                        percent = (itemsRebateSum / hcfRebateItemsSum) * 100;
                        return percent;
                    }
                    break;
                }
                case 13: {
                    //AMA
                    var amaRebateItemsSum = items.reduce(
                        (sum, { rebateAma }) => sum + rebateAma,
                        0,
                    );
                    if(amaRebateItemsSum > 0){
                        percent = (itemsRebateSum / amaRebateItemsSum) * 100;
                        return percent;
                    }
                    break;
                }
            }
        }
        return percent; 
    }

    export const getMinHourlyRate = (
        fundData,
        isQuote = true,
        billingData = {},
    ) => {
        const defaultHourlyRate = 200;

        if (!fundData) return defaultHourlyRate;

        const { items } = fundData;

        const itemsRebateSum = items.reduce(
            (sum, { hfRebate }) => sum + hfRebate,
            0,
        );

        if (isQuote) {
            const timeCode = items.find((item) => item.type == "Time");

            const hoursNumber = getBigIntervalHours(timeCode.itemShortTitle);

            return itemsRebateSum / hoursNumber;
        } else {
            const { startDate, endDate } = billingData;

            if (!startDate || !endDate) return defaultHourlyRate;

            const dateStart = new Date(startDate);
            const dateEnd = new Date(endDate);

            const timeDiff = Math.abs(dateEnd - dateStart);

            const hoursNumber = (timeDiff / (1000 * 60 * 60)).toFixed(2);

            return itemsRebateSum / hoursNumber;
        }
    };

    export const getMinTotalFee = (fundData, isAsaCodes = false, insuranceTye) => {
        if (!fundData) return 200;

        const { items } = fundData;

        if(insuranceTye == 15 && isAsaCodes) {
            const itemsUnitsSum = items.reduce(
                (sum, { units }) => sum + units,
                0,
            );

            return itemsUnitsSum * 20;
        }

        const itemsRebateSum = items.reduce(
            (sum, { hfRebate }) => sum + hfRebate,
            0,
        );

        return itemsRebateSum;
    };

    export const getInitTotalFee = (fundData) => {
        if (!fundData) return 200;

        const { items } = fundData;

        const itemsRebateSum = items.reduce(
            (sum, { medRebate }) => sum + medRebate,
            0,
        );

        return itemsRebateSum;
    };

    export const patientPaysTotalFeeBasedOnCalculation = async (
        isFromSlider = false,
        insuranceType,
        funds,
        billingObj = {},
        encounter = {}
    ) => {
        let patientPaysTotalFee = false; //default value

        let gapFeeBtnDisabled = false,
            totalFeeBtnDisabled = false;

        let disableText = "";

        if (insuranceType == 11) {
            gapFeeBtnDisabled = true;
            if (isObjectEmpty(funds)) patientPaysTotalFee = false;
            else {
                patientPaysTotalFee = funds.gap > 0;
                disableText =
                    "Self insured, overseas, cosmetic and 3rd party patients are are always billed total fee.";
            }
        }

        if (insuranceType != 11) {
            let hbfWaProviderChoice = await isHBFWAProviderChoiceEncounter(encounter, billingObj);
            if(!billingObj.patientPaysTotalFee && !hbfWaProviderChoice) { //IMP: this if might cause issues on the HBF WA provider choice encounters
                if (!funds?.withinFundRules) {
                    if(hbfWaProviderChoice)
                        return null;
                    patientPaysTotalFee = true;
                }
                else if (isFromSlider) {
                    patientPaysTotalFee = false;
                }
            } else {
                return null;
            }
        }

        if ((insuranceType == 10 && billingObj.patientInsuranceId == 0) || insuranceType == 15 || insuranceType == 18) {
            patientPaysTotalFee = true;
            gapFeeBtnDisabled = true;
            disableText = `Self insured, overseas, cosmetic and 3rd party patients are are always billed total fee.`;
        }

        if ([16, 17, 25, 26, 20, 30].includes(insuranceType)) {
            patientPaysTotalFee = false;
            totalFeeBtnDisabled = true;
            disableText = `Patients with ${getInsuranceType(insuranceType)} insurance never pay total fee.`;
        }

        var response = {
            patientPaysTotalFee,
            gapFeeBtnDisabled,
            totalFeeBtnDisabled,
            disableText,
        };

        return response;
    };

    export const getNotExceedingGapChargeValue = (
        fundsData,
        funds,
        billingObj,
        selectorProperties,
    ) => {
        let res = selectorProperties.amountSelector;

        if (
            isObjectEmpty(fundsData) ||
            isObjectEmpty(funds) ||
            isObjectEmpty(billingObj)
        )
            return res;

        const { maxGap, items } = fundsData;
        const { sumInsuranceRebates, nrHours } = funds;

        switch (billingObj.type) {
            case 2: // unit value
                const sum1 = maxGap + sumInsuranceRebates;
                const sum2 = items.reduce((sum, { units }) => sum + units, 0);
                return parseFloat(sum1 / sum2);
            case 3: // gap fee
                return maxGap;
            case 4:
                const sum = maxGap + sumInsuranceRebates;
                return parseFloat(sum / nrHours);
            case 5:
                return parseFloat(maxGap + sumInsuranceRebates);
            default:
                return res;
        }
    };

    export const billingRuleCalculateTotals = async (
        doctorId,
        encounterId,
        billingDataId,
        billingObj = {},
    ) => {
        let resolve, error;

        // no rule was applied for this encounter, mark it type as gap fee (3) with amount 0
        if (billingObj.type == null || billingObj.type == undefined)
            billingObj = { ...billingObj, type: 3, amount: 0 };

        const data = {
            accountId: doctorId,
            encounterId,
            billingDataId,
            rule: {
                type: billingObj.type,
                amount: billingObj.amount,
            },
        };

        await apiMethods.postMethod
            .calculateBillingRuleTotalFee(data)
            .then((res) => {
                if (!res || res.error) error = res.error ?? "";
                else resolve = { ...res };
            })
            .catch((err) => (error = err));

        return {
            resolve,
            error,
        };
    };

    export const getBigIntervalHours = (shortTitle) => {
        try {
            shortTitle = shortTitle.split("(")[0];
            //remove string from short title
            shortTitle = shortTitle
                .replaceAll("HOURS", "")
                .replaceAll("HOUR", "")
                .replaceAll("MINUTES", "")
                .replaceAll("OR", "")
                .replaceAll("LESS", "")
                .replaceAll("hours", "")
                .replaceAll("minutes", "")
                .replaceAll("to", "")
                .replaceAll("TO", "")
                .replaceAll("   ", " ");

            let ranges = shortTitle.split(" ");
            let start = getMinutesFromHour(ranges[0]);
            let end = getMinutesFromHour(ranges[1]);
            if (end == 0) {
                return parseFloat(start / 60); //get minimum interval in hours
            }
            return parseFloat(end / 60);
        } catch (e) {
            return 0;
        }
    };

    const getMinutesFromHour = (value) => {
        try {
            if (!value.includes(":")) {
                return parseInt(value);
            }
            var parts = value.split(":");
            var hour = parts[0];
            var minute = parts[1];
            var hourInt = parseInt(hour);
            var minuteInt = parseInt(minute);
            if (minuteInt != null && hourInt != null)
                return minuteInt + hourInt * 60;
            return 0;
        } catch (e) {
            return 0;
        }
    };

    export const syncItemsAfterCalculation = async (
        resolve,
        latestObj,
        fundData = {},
    ) => {
        const {
            gap,
            totalFee,
            usingAmaRates,
            insurance,
            itemsFees,
            whitinFundRules,
        } = resolve;

        const {
            useAsaCodes,
            asaData,
            mbsData,
            totalFee: objTotalFee,
            asaTimeData,
            billingType,
            calculationAmount,
        } = latestObj;

        if (itemsFees) {
            if (useAsaCodes && asaData?.length)
                latestObj.asaData = asaData.map((asa) => {
                    const itemFee = itemsFees.find(
                        (fee) =>
                            fee.itemIdentifier.toLowerCase() ==
                                asa.itemCode.toLowerCase() &&
                            fee.subItemIdentifier.toLowerCase() ==
                                asa.subItemCode.toLowerCase(),
                    );
                    return itemFee
                        ? {
                              ...asa,
                              feeCharged: itemFee.feeCharged,
                              rebate: itemFee.rebate,
                              fieldChange: itemFee.fieldChange,
                          }
                        : asa;
                });
            else if (!useAsaCodes && mbsData?.length)
                latestObj.mbsData = mbsData.map((mbs) => {
                    const itemFee = itemsFees.find(
                        (fee) =>
                            fee.itemIdentifier == mbs.itemNum.toString() &&
                            fee.subItemIdentifier == mbs.subItemNum.toString(),
                    );

                    return itemFee
                        ? {
                              ...mbs,
                              feeCharged: itemFee.feeCharged,
                              rebate: itemFee.rebate,
                              fieldChange: itemFee.fieldChange,
                          }
                        : mbs;
                });
        }

        latestObj.actualGap = gap;
        latestObj.totalFee = totalFee;

        latestObj.rebate = insurance;

        latestObj.usingAmaRates = usingAmaRates;

        latestObj.withinFundRules = whitinFundRules;

        if (
            // insuranceTypesMayAllowAmaBillingRule.includes(insuranceType) &&
            // usingAmaRates &&
            asaTimeData?.length &&
            fundData &&
            !isObjectEmpty(fundData)
        ) {
            if (billingType && billingType == 2) {
                // SetUnitValue - clean multiplication
                const unitValue = calculationAmount ?? Number(0);
                latestObj.asaTimeData = latestObj.asaTimeData.map((td) => {
                    td.feeCharged = td.units * unitValue;
                    return td;
                });
            } else {
                // SetTotalFee - remainder approach to avoid rounding errors
                const itemsFeeSum = latestObj.asaData?.reduce((sum, item) => sum + (item.feeCharged || 0), 0) || 0;
                const roundedItemsFeeSum = Math.round(itemsFeeSum * 100) / 100;
                latestObj.asaTimeData = latestObj.asaTimeData.map((td) => {
                    td.feeCharged = totalFee - roundedItemsFeeSum;
                    return td;
                });
            }
        }

        return latestObj;
    };

    export const getCalculatedUnitValue = (items, latestObj, fundResults) => {
        const { useAsaCodes, asaTimeData } = latestObj;
        const { totalFee } = fundResults;

        let numOfUnits = items.reduce((sum, { units }) => (sum += units), 0);

        if (useAsaCodes && asaTimeData && asaTimeData.length)
            numOfUnits += asaTimeData[0].units;

        return Math.round((totalFee / numOfUnits) * 100) / 100;
    };

    export const getCalculatedHourlyRate = (
        items,
        latestObj,
        fundResults,
        isFromQuote,
    ) => {
        const { useAsaCodes, asaTimeData, startDate, endDate } = latestObj;
        const { totalFee } = fundResults;

        if (useAsaCodes) {
            if (!asaTimeData || !asaTimeData.length) return 0;

            let minutes = 0;

            const timeUnits = asaTimeData[0].units;

            if (timeUnits <= 8) minutes = timeUnits * 15;
            else if (timeUnits <= 20) minutes = 8 * 15 + (timeUnits - 8) * 10;
            else minutes = 8 * 15 + 12 * 10 + (timeUnits - 20) * 5;

            const hours = minutes / 60;

            return Number(totalFee / hours).toFixed(2);
        } else if (isFromQuote) {
            const hasTimeItem = items.some((item) => item.type == "Time");

            if (!hasTimeItem) return 0;

            const timeItem = items.find((item) => item.type == "Time");

            const hours = getBigIntervalHours(timeItem.itemShortTitle);

            return Number(totalFee / hours).toFixed(2);
        } else if (!startDate || !endDate) return 0;
        else {
            const hours = convertTimeRangeInMin(startDate, endDate) / 60;

            return Number(totalFee / hours).toFixed(2);
        }
    };

    export const isWcOrTacOrDefOrCusOrOverAMARates = (billingData) => {
        const { insuranceType, useAsaCodes, usingAmaRates } = billingData;

        if (isNaN(insuranceType)) return false;

        if (
            [
                DirectInsuranceType.WorkersCompensation,
                DirectInsuranceType.TrafficAccident,
            ].includes(insuranceType) &&
            (useAsaCodes || usingAmaRates)
        )
            return true;

        if (
            [
                DirectInsuranceType.Overseascover,
                DirectInsuranceType.Cosmetic,
                DirectInsuranceType.ThirdPartyInsurer,
            ].includes(insuranceType) &&
            useAsaCodes
        )
            return true;

        if (insuranceType == DirectInsuranceType.DefenceAMA && usingAmaRates)
            return true;

        return false;
    };
</script>
